<div
  class="tw-flex tw-flex-col tw-w-full tw-bg-color-surface-elevated tw-rounded-[22px_22px_0_0] tw-shadow-[0px_-6px_30px_0px_rgba(13,18,31,0.3)]"
  style="padding-bottom: calc(0.5rem + env(safe-area-inset-bottom, 0px))"
>
  <div class="tw-flex tw-justify-center tw-pt-2.5 tw-pb-1.5">
    <div class="tw-w-9 tw-h-1 tw-rounded-full tw-bg-color-border-subtle"></div>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-0.5 tw-px-5 tw-pt-1 tw-pb-3.5">
    <p
      id="grocery-row-actions-title"
      class="tw-m-0 tw-text-base tw-font-semibold tw-text-color-text-default tw-truncate"
    >
      {{ data.itemName }}
    </p>
    @if (data.priceLabel) {
      <p class="tw-m-0 tw-text-sm tw-font-medium tw-text-color-text-tertiary">
        {{ data.priceLabel }}
      </p>
    }
  </div>
  <div class="tw-h-px tw-w-full tw-bg-color-border-subtle"></div>

  @if (data.showRefresh) {
    <button
      type="button"
      class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-px-5 tw-py-3.5 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-left"
      [disabled]="data.refreshing()"
      [class.tw-opacity-50]="data.refreshing()"
      (click)="choose('refresh')"
    >
      <icon name="refresh-line" [size]="5" currentColor="color-icon-default"></icon>
      <span class="tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0">
        <span class="tw-text-sm tw-font-semibold tw-text-color-text-default">
          {{ (data.refreshing() ? "groceryRefreshingPrices" : "groceryRefreshPrices") | i18n }}
        </span>
        <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">
          {{ "groceryRefreshPriceHintMobile" | i18n }}
        </span>
      </span>
    </button>
  }

  <button
    type="button"
    class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-px-5 tw-py-3.5 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-left"
    (click)="choose('archive')"
  >
    <icon name="archive" [size]="5" currentColor="color-icon-default"></icon>
    <span class="tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0">
      <span class="tw-text-sm tw-font-semibold tw-text-color-text-default">
        {{ "groceryArchiveItem" | i18n }}
      </span>
      <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">
        {{ "groceryArchiveItemHint" | i18n }}
      </span>
    </span>
  </button>

  <div class="tw-h-px tw-w-full tw-bg-color-border-subtle"></div>

  <button
    type="button"
    class="tw-flex tw-items-center tw-gap-3.5 tw-w-full tw-px-5 tw-py-3.5 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-left"
    (click)="choose('remove')"
  >
    <icon name="trash-bin" [size]="5" currentColor="color-status-error-text"></icon>
    <span class="tw-text-sm tw-font-semibold tw-text-color-status-error-text">
      {{ "groceryRemoveItem" | i18n }}
    </span>
  </button>

  <div class="tw-h-px tw-w-full tw-bg-color-border-subtle tw-my-1.5"></div>

  <button
    type="button"
    class="tw-w-full tw-py-3 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-center tw-text-sm tw-font-semibold tw-text-color-text-default"
    (click)="cancel()"
  >
    {{ "cancel" | i18n }}
  </button>
</div>
